/**
 * Accessibility fix (WCAG 2.4.3 / 2.1.1)
 *
 * Flickity carousels (e.g. the product-card image slider on PLP/collection
 * grids) keep every slide's markup in the DOM and just translate non-active
 * cells off-screen -- they are never display:none. That leaves every link
 * inside every off-screen slide reachable by Tab, so tabbing through one
 * product card walked through as many duplicate "go to this product" links
 * as it has images, all pointing at the same URL.
 *
 * This hides non-selected cells from the accessibility tree (aria-hidden)
 * and removes their interactive content from the Tab order (tabindex="-1"),
 * restoring both on whichever cell Flickity currently has selected. It is
 * intentionally a separate, additive file (matches the pattern used by
 * assets/slider-autoplay-toggle.js) so it can be reviewed/removed without
 * touching the minified theme.js bundle.
 *
 * .product-card-images-slider carousels are created via a bespoke code
 * path (slider.flickityInstance = new Flickity(...)) rather than the
 * theme's generic Slider class, so they never dispatch the theme's own
 * "theme:slider:loaded" event -- this polls for them directly. Other
 * Flickity sliders (hero, tab-collections, etc.) DO dispatch that event
 * and are picked up through it below.
 *
 * Collection.reinitiateSlider() (theme.dev.js) destroys and replaces
 * .product-card-images-slider's Flickity instance whenever the grid
 * reloads (filter/sort change, pagination), handing back a NEW instance
 * on the SAME DOM element. Tracking "already wired" per-element would
 * mean that new instance never gets wired at all -- so this tracks the
 * wired instance itself on the element and re-wires whenever it changes.
 */
(function () {
  'use strict';

  var FOCUSABLE_SELECTOR = 'a, button, input, select, textarea, [tabindex]';

  function updateSlideFocusability(flkty) {
    if (!flkty || !flkty.cells) return;
    flkty.cells.forEach(function (cell) {
      var isSelected = cell.element === flkty.selectedElement;
      cell.element.setAttribute('aria-hidden', isSelected ? 'false' : 'true');

      // The cell element itself is very often the focusable node (e.g.
      // product-grid-item.liquid's carousel cells ARE the <a> tags, with
      // no wrapper div) -- querySelectorAll alone only matches descendants
      // and would silently skip it, leaving the real Tab stop untouched.
      var targets = cell.element.matches(FOCUSABLE_SELECTOR) ? [cell.element] : [];
      targets = targets.concat(Array.prototype.slice.call(cell.element.querySelectorAll(FOCUSABLE_SELECTOR)));

      targets.forEach(function (el) {
        if (isSelected) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', '-1');
        }
      });
    });
  }

  function wireCarousel(carousel, flktyOverride) {
    if (!carousel) return;
    var flkty = flktyOverride || carousel.flickityInstance ||
      (window.Flickity && window.Flickity.data && window.Flickity.data(carousel));
    if (!flkty || carousel.__carouselFocusFlkty === flkty) return;
    carousel.__carouselFocusFlkty = flkty;
    updateSlideFocusability(flkty);
    flkty.on('select', function () {
      updateSlideFocusability(flkty);
    });
  }

  function scanProductCardSliders() {
    document.querySelectorAll('.product-card-images-slider.flickity-enabled').forEach(function (carousel) {
      wireCarousel(carousel);
    });
  }

  // Product-card sliders can appear at any time (pagination, infinite
  // scroll, Nosto re-renders), so this keeps checking rather than running
  // once -- a class-name query + WeakSet check every 500ms is negligible.
  setInterval(scanProductCardSliders, 500);
  scanProductCardSliders();

  document.addEventListener('theme:slider:loaded', function (evt) {
    var sliderInstance = evt.detail && evt.detail.slider;
    if (!sliderInstance || !sliderInstance.flkty || !sliderInstance.slideshow) return;
    wireCarousel(sliderInstance.slideshow, sliderInstance.flkty);
  });
})();
